export const isValidUrl = (url: string): boolean => {
  if (!url) {
    return false;
  }

  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};

export const validateUrlWithDomains = (url, orginsList: string[] = [], withHostName = false) => {
  let isValidUrl = false;
  let errorMessage = '';
  try {
    // this will throw an error if the url is not valid
    // TODO we should not be using `try/catch` statements as control flow
    new URL(url);
    isValidUrl =
      /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
        url
      );

    if (!isValidUrl) {
      errorMessage = 'Please enter a valid URL in the format of http(s)://yourdomain.com';
    }

    if (isValidUrl && orginsList?.length) {
      isValidUrl = !withHostName
        ? orginsList.includes(new URL(url)?.origin) || orginsList.includes(`${new URL(url)?.origin}/`)
        : orginsList.includes(new URL(url)?.hostname) || orginsList.includes(`${new URL(url)?.hostname}/`);
      console.log('isValidUrl', orginsList, {
        withHostName,
        hostName: new URL(url)?.hostname,
        origin: new URL(url)?.origin,
      });

      if (!isValidUrl) {
        errorMessage = 'Please provide URL that are compatible with our domain setup.';
      }
    }
  } catch (err) {
    isValidUrl = false;
    errorMessage = 'Please enter a valid URL in the format of http(s)://yourdomain.com';
  }
  return { isValidUrl, errorMessage };
};

export const getHostNameList = (urlList = [], extractKey = 'hostname') => {
  if (!['origin', 'hostname'].includes(extractKey)) {
    return;
  }
  const hostNameList: string[] = [];
  urlList?.forEach((url) => {
    if (url) {
      hostNameList.push(new URL(url)?.[extractKey]);
    }
  });
  return hostNameList;
};

export const getHostNameByUrl = (url) => {
  let hostName = url;
  try {
    hostName = new URL(url).hostname;
  } catch (error) {
    //do nothing
  }
  return hostName;
};
